/**
 * Contato oficial de suporte do SmartApp.
 *
 * Este é o número do WhatsApp **homologado na Cloud API da Meta** ("Suporte
 * SmartApp"), o mesmo que atende os tickets do módulo de Atendimentos. Toda
 * referência interna de "falar com o suporte" (seção Suporte, FlipLink, SmartIA,
 * e-mails de contrato, etc.) deve redirecionar para cá — nunca duplicar o número
 * solto pelo código.
 *
 * Apenas dígitos, no formato internacional (sem `+`, sem espaços), como exigido
 * pelo link `wa.me`.
 */
export const SUPORTE_WHATSAPP_NUMERO = '5511936195847';

/** URL `wa.me` pronta para abrir uma conversa com o suporte oficial. */
export const SUPORTE_WHATSAPP_URL = `https://wa.me/${SUPORTE_WHATSAPP_NUMERO}`;
